<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12>
   			<v-card>
	   			<v-card-title>

			      <v-text-field v-model="filter.first_name" label="First Name" class="mr-3"></v-text-field>
		          <v-text-field v-model="filter.email" label="Email" class="mr-3"></v-text-field>
		          <v-text-field v-model="filter.mobile" label="Mobile" class="mr-3"></v-text-field>
		          <search-btn @click="filterData" />
			      
			      <v-spacer></v-spacer>
			      
			      <v-dialog v-model="dialog" max-width="600px" v-if="hasCreateAccess">
			        <v-btn slot="activator" round small dark color="primary" class="ml-4">Add New</v-btn>
			        <v-form v-model="validForm">
				        <v-card>
				          <v-card-title>
				            <span class="headline" v-text="item.id ? 'Update User' : 'Add User'"></span>
				          </v-card-title>

				          <v-card-text>
				            <v-container grid-list-md py-0>
				              <v-layout wrap>
				                <v-flex xs12 sm6>
				                  <v-text-field :rules="fNameRules" counter="50" v-model="item.first_name" label="First Name"></v-text-field>
				                </v-flex>
				                <v-flex xs12 sm6>
				                  <v-text-field counter="50" maxlength="50" v-model="item.last_name" label="Last Name"></v-text-field>
				                </v-flex>
				                <v-flex xs12 sm6>
				                  <v-text-field :readonly="item.id ? true : false" :rules="uNameRules" counter="25" v-model="item.username" label="Username"></v-text-field>
				                </v-flex>
				                <v-flex xs12 sm6 md6>
				                  <v-text-field :rules="emailRules" counter="50" v-model="item.email" label="Email"></v-text-field>
				                </v-flex>
				                <v-flex xs12 sm6 md6 v-if="!item.id">
				                  <v-text-field :rules="passwordRules" counter="20" prepend-icon="lock" :append-icon="showPasswords ? 'visibility_off' : 'visibility'" :type="showPasswords ? 'text' : 'password'" v-model="item.password" label="Password" @click:append="showPasswords = !showPasswords"></v-text-field>
				                </v-flex>
				                <v-flex xs12 sm6 md6 v-if="!item.id">
				                  <v-text-field :rules="passwordRules" counter="20" prepend-icon="lock" :type="showPasswords ? 'text' : 'password'" v-model="item.password1" label="Re-enter Password"></v-text-field>
				                </v-flex>
				                <v-flex xs12 sm6>
				                  <v-text-field :rules="mobileRules" mask="#### ### ###" counter="10" v-model="item.mobile" label="Mobile"></v-text-field>
				                </v-flex>
				                <v-flex xs12 sm6>
				                	<v-select :rules="requireRule" :items="userRolesList" label="Privilage" v-model="item.privilage" item-text="role" item-value="id"></v-select>
				                </v-flex>
				                <!-- <v-flex xs12 sm6>
				                	<v-dialog ref="dialog" v-model="dob_modal" :return-value.sync="item.birth_date" persistent lazy full-width width="290px">
					                  <v-text-field :rules="requireRule" v-model="item.birth_date" label="Date Of Birth" slot="activator" prepend-icon="event" readonly></v-text-field>
					                  <v-date-picker v-model="item.birth_date" scrollable>
							            <v-spacer></v-spacer>
							            <v-btn flat color="primary" @click="dob_modal = false">Cancel</v-btn>
							            <v-btn flat color="primary" @click="$refs.dialog.save(item.birth_date)">OK</v-btn>
							          </v-date-picker>
							        </v-dialog>
				                </v-flex> -->
				                <v-flex xs12 sm6>
				                	<v-autocomplete :rules="requireRule" v-model="item.country" :items="countries" item-text="country" item-value="id" label="Country"></v-autocomplete>
				                </v-flex>
				                <v-flex xs12 sm6>
				                	<v-autocomplete :rules="requireRule" v-model="item.province" :items="states" item-text="state" item-value="id" label="State"></v-autocomplete>
				                </v-flex>
				                <v-flex xs12 sm6>
				                	<v-autocomplete :rules="requireRule" v-model="item.city" :items="cities" item-text="city" item-value="id" label="City"></v-autocomplete>
				                </v-flex>
				                <v-flex xs12 sm6></v-flex>
				                <v-flex xs12 sm6 class="branch-type">
				                	<p>User belongs to:</p>
				                	<v-radio-group v-model="item.branch_type" row>
								      <v-radio label="Head Office" :value="config.branchTypes.distributor"></v-radio>
								      <v-radio label="Branches" :value="config.branchTypes.retailer"></v-radio>
								    </v-radio-group>
				                </v-flex>
				                <v-flex xs12 sm6 v-if="item.branch_type == config.branchTypes.distributor">
				                	<v-autocomplete :rules="requireRule" v-model="item.branch" :items="distributors" item-text="title" item-value="id" label="Branch"></v-autocomplete>
				                </v-flex>
				                <v-flex xs12 sm6 v-if="item.branch_type == config.branchTypes.retailer">
				                	<v-autocomplete :rules="requireRule" v-model="item.branch" :items="retailers" item-text="title" item-value="id" label="Branch"></v-autocomplete>
				                </v-flex>
				              </v-layout>
				            </v-container>
				          </v-card-text>

				          <v-card-actions>
				            <v-spacer></v-spacer>
				            <v-btn color="blue darken-1" :disabled="processing" flat @click.native="close">Cancel</v-btn>
			                <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="item.id ? updateItem() : addItem()" v-text="item.id ? 'Update' : 'Save'"></v-btn>
				          </v-card-actions>
				        </v-card>
				      </v-form>
			      </v-dialog>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="users"
				    v-model="selected"
				    item-key="id"
      				hide-actions
      				disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props" v-if="isUserVisible(props.item.privilage)">
				      <td>{{ props.item.first_name }}</td>
				      <td>{{ props.item.username }}</td>
				      <td>{{ props.item.email }}</td>
				      <td>{{ props.item.mobile }}</td>
				      <td><v-switch :key="props.item.id" v-model="props.item.is_active" v-on:change="update(props.item)" :disabled="!props.item.is_editable"></v-switch></td>
				      <td>{{ props.item.privilage | userPrivilage(userRoles) }}</td>
				      <td class="align-center justify-center layout px-0">
				      	<edit-btn v-if="props.item.is_editable" :item="props.item" />
				      	<v-icon small class="mr-1" v-if="hasEditAccess && isSuperAdmin && props.item.is_editable && !isLoggedInUser(props.item.id)" @click="openPasswordReset(props.item)" title="Reset Password">lock</v-icon>
                		<delete-btn v-if="props.item.is_editable && !isLoggedInUser(props.item.id)" :item="props.item" />
				      </td>
				    </template>
				    <template slot="no-data" v-if="!processing">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				</v-data-table>
				
				<v-pagination @loadPage="loadPage" />

	          <action-dialog action="delete" :status="deleteDialog" @close="closeDeleteDialog" @success="deleteItem(users)" />

			</v-card>
   		</v-flex>

   		<v-dialog v-model="passwordDialog" max-width="350px" persistent v-if="resetPasswordItem">
   			<v-form v-model="validResetForm">
		        <v-card>
		          <v-card-title>
		            <span class="headline">Reset Password</span>
		          </v-card-title>
		          <v-card-text>
		          	<v-flex xs12>
		            	<v-text-field readonly v-model="resetPasswordItem.username" label="Username"></v-text-field>
		            </v-flex>
	                <v-flex xs12>
	                  <v-text-field :rules="passwordRules" counter="20" prepend-icon="lock" :append-icon="showPasswords ? 'visibility_off' : 'visibility'" :type="showPasswords ? 'text' : 'password'" v-model="resetPasswordItem.password" label="Password" @click:append="showPasswords = !showPasswords"></v-text-field>
	                </v-flex>
	                <v-flex xs12>
	                  <v-text-field :rules="passwordRules" counter="20" prepend-icon="lock" :type="showPasswords ? 'text' : 'password'" v-model="resetPasswordItem.password1" label="Re-enter Password"></v-text-field>
	                </v-flex>
		          </v-card-text>

		          <v-card-actions class="pa-3">
		            <v-spacer></v-spacer>
		            <v-btn color="blue darken-1" flat small :disabled="processing" @click.prevent="closePasswordReset">Cancel</v-btn>
		            <v-btn color="blue darken-1" flat small :disabled="processing || !validResetForm" :loading="processing" @click.prevent="resetPassword">Reset Password</v-btn>
		          </v-card-actions>
		        </v-card>
		    </v-form>
	    </v-dialog>

   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    
    name: 'UsersView',

    data () {
      	return {
      		model: 'admin',
	      	title: "View Users",
	      	validForm: false,
	      	processing: false,
	        valid: false,
	      	userRoles: [],
	      	users: [],
	        selected: [],
	        headers: [
	          	{ text: 'First Name', value: 'first_name'},
	          	{ text: 'Username', value: 'username' },
	          	{ text: 'Email', value: 'email' },
	          	{ text: 'Mobile', value: 'mobile' },
	          	{ text: 'Status', value: 'is_active' },
	          	{ text: 'Privilage', value: 'privilage' },
	          	{ text: 'Actions', value: 'id', sortable: false }
	        ],
	        filter: {
	          first_name: "",
	          email: "",
	          mobile: ""
	        },
	        defaultItem: {
	        	id: "",
	        	first_name: "",
	        	last_name: "",
	        	username: "",
	        	email: "",
	        	mobile: "",
	        	privilage: "",
	        	is_active: 0,
	        	is_editable: 1,
          		is_deleted: false,
	        	// birth_date: "",
	        	country: this.getDefault('country'),
	        	province: "",
	        	city: "",
	        	branch_type: null,
	        	branch: ""
	        },
	        item: {},
	        resetPasswordItem: {},
	        validResetForm: false,
	        passwordDialog: false,
	        dialog: false,
        	deleteDialog: false,
	        showPasswords: false,
	        dob_modal: false,
	        states: [],
	        cities: [],
	        distributors: [],
	        retailers: [],
	        fNameRules: [
	          	v => !!v || 'First Name is required',
	          	v => v && v.length >= 4 || 'Must be more than 3 characters',
	          	v => v && v.length <= 50 || 'Maximum 50 characters allowed'
	        ],
	        uNameRules: [
	          	v => !!v || 'Username is required',
	          	v => v && v.length >= 5 || 'Must be more than 4 characters',
	          	v => v && v.length <= 25 || 'Maximum 25 characters allowed'
	        ],
	        emailRules: [
	          	v => !!v || 'E-mail is required',
				v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
	          	v => v && v.length <= 50 || 'Maximum 50 characters allowed'
	        ],
	        passwordRules: [
	          	v => !!v || 'Password is required',
	          	v => v && v.length >= 5 || 'Must be more than 4 characters',
	          	v => v && v.length <= 20 || 'Maximum 20 characters allowed'
	        ],
	        mobileRules: [
	          	v => !!v || 'Mobile Number is required',
	          	v => v && v.length >= 10 || 'Must be 10 characters',
	          	v => v && v.length <= 10 || 'Maximum 10 characters allowed'
	        ],
	        requireRule: [
	        	v => !!v || 'Field is required'
	        ]
      	}
    },

    methods: {

    	getUserRoles () {
	        return this.axios.get(this.config.apis.viewUserRoles)
    	},

    	getDistributors () {
	        return this.axios.get(this.config.apis.getAllDistributors)
    	},

    	getRetailers () {
	        return this.axios.get(this.config.apis.getAllRetailers)
    	},

      	getCities (state) {
	        this.processing = true
	        this.cities = []
	        this.axios.get(this.config.apis.getCitiesByState.replace(":state", state))
	        .then((response) => {
	            this.processing = false
	            if (this.isSuccessResponse(response)) {
	            	this.cities = response.data.data
	            }
	        })
	        .catch((error) => {
	            this.processing = false
	        })
      	},

      	loadPage () {

	        let api_path = this.config.apis.viewUsers.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)
	        
	        let filterArray = []

	        for (const [key, val] of Object.entries(this.filter)) {
	          filterArray.push(`${key}=${val}`)
	        }

	        api_path += '?' + filterArray.join('&')

	        this.processing = true
	        this.axios.get(api_path)
	        .then((response) => {
	            this.processing = false
	            if (this.isSuccessResponse(response)) {
	            	this.users = response.data.data.items
	            	this.$store.commit('setItemsCount', response.data.data.total)
	            }
	            else{
	            	this.users = []
	            	this.$store.commit('setItemsCount', 0)
	            }
	        })
	        .catch((error) => {
	            this.processing = false
	        })
      	},

      	addItem () {
	      	this.processing = true
	        this.axios.post(this.config.apis.addUser, this.item)
          	.then((response) => {
	            if (this.isSuccessResponse(response)) {
	              	
	              	this.notifySuccess('insertSuccess')

	              	let new_item = Object.assign({}, this.item)
	              	new_item.id = response.data.data.id

	              	this.users.unshift(new_item)

	              	this.close()
	            }
	            else{
	              	this.notifyError('insertError')
	            }
	            this.processing = false
          	})
          	.catch((error) => {
            	this.processing = false
          	})
      	},

	    updateItem () {
	      	this.update(this.item)
	    },

      	update (item) {
	      	this.processing = true
	        this.axios.put(this.config.apis.updateUser.replace(":id", item.id), item)
          	.then((response) => {
            	if (this.isSuccessResponse(response)) {
              		this.notifySuccess('updateSuccess')
              		this.close()
            	}
            	else{
              		this.notifyError('updateError')
            	}
            	this.processing = false
          	})
          	.catch((error) => {
            	this.processing = false
          	})
      	},

      	close () {
        	this.dialog = false
	        setTimeout(() => {
	          	this.item = this.extend({}, this.defaultItem)
	        }, 300)
      	},

      	editItem (item) {
	        this.item = item
	        this.dialog = true
      	},

	    isUserVisible (privilage) {
	    	return this.isSuperAdmin || (!this.isSuperAdmin && parseInt(privilage) !== this.config.userRoles.superAdmin)
	    },

	    isLoggedInUser (id) {
	    	return id === this.loggedInUser.id
	    },

	    openPasswordReset (item) {
	    	this.resetPasswordItem = {
	    		id: item.id,
	    		username: item.username,
	    		password: '',
	    		password1: ''
	    	}
	    	this.passwordDialog = true
	    },

	    closePasswordReset () {
	    	this.resetPasswordItem = {
	    		id: '',
	    		password: '',
	    		password1: ''
	    	}
	    	this.passwordDialog = false
	    },

      	resetPassword () {
      		if (!this.resetPasswordItem.id) {
      			return this.notifyError('updateError')
      		}
      		else if(this.resetPasswordItem.password !== this.resetPasswordItem.password1){
      			return this.notifyError('passwordsMismatch')
      		}
      		let api_path = this.config.apis.resetUserPassword.replace(":id", this.resetPasswordItem.id)
      		let data = {
      			pw: this.resetPasswordItem.password,
      			pw1: this.resetPasswordItem.password1
      		}
	      	this.processing = true
	        this.axios.put(api_path, data)
          	.then((response) => {
            	if (this.isSuccessResponse(response)) {
              		this.notifySuccess('updateSuccess')
              		this.closePasswordReset()
            	}
            	else{
              		this.notifyError('updateError')
            	}
            	this.processing = false
          	})
          	.catch((error) => {
            	this.processing = false
          	})
      	},

    },

    created () {
    	let breadcrumbs = [
	      	{
	          	text: 'Dashboard',
	          	disabled: false,
	          	href: '/dashboard'
	        },
	        {
	          	text: 'Users',
	          	disabled: true
	        },
	        {
	          	text: 'View',
	          	disabled: true
	        }
       	]

       	this.$store.commit('setBreadcrumbs', breadcrumbs)
       	this.$store.commit('setPageTitle', 'Manage Users')
    },

    mounted () {

    	this.getCountries()

    	this.processing = true
    	Promise.all([this.getUserRoles(), this.getDistributors(), this.getRetailers()])
		.then(([rolesResponse, distributorsResponse, retailersResponse]) => {
		    this.processing = false
            this.userRoles = this.isSuccessResponse(rolesResponse) ? rolesResponse.data.data : []
            this.distributors = this.isSuccessResponse(distributorsResponse) ? distributorsResponse.data.data : []
            this.retailers = this.isSuccessResponse(retailersResponse) ? retailersResponse.data.data : []
		})
        .catch((error) => {
            this.processing = false
        })

        this.defaultItem.branch_type = this.config.branchTypes.distributor

    	this.item = this.extend({}, this.defaultItem)
    },

    watch: {
      	dialog (val) {
        	val || this.close()
      	},
      	'item.country': function(val, oldVal){
            if (val && val != oldVal) {
               this.getStatesByCountry(val).then( states => {
                this.states = states
              })
            }
        },
      	'item.province': function(val, oldVal){
            if (val && val != oldVal) {
                this.getCities(val)
            }
        }
    },

    computed: {
    	userRolesList () {
    		let $this = this
    		return this.userRoles.filter(function(item){
		    	return item.id !== $this.config.userRoles.superAdmin
		    })
    	}
    },

    filters: {
	  	userPrivilage (value, roles) {
		    let privilage = roles.filter(function(item){
		    	return item.id == value
		    })

	    	return privilage.length ? privilage[0].role : ""
	  	}
	}

  }
</script>
